import { getQueryStringMap } from "../../helpers/query-string-map";
import moment = require("moment");
import { AdaTag, DiscountTag } from '../../enums';

/**
 * Interface to define startup-state (state from queryString arguments or localStorage).
 */
export interface IStartupState {
    currentDate: string;
    startDate: string;
    endDate: string;
    dateRangeFromQueryString: boolean;
    typeFilter: string[];
    genreFilter: string[];
    venueFilter: string[];
    availabilityFilter: string[];
}

let startupState = JSON.parse(localStorage.getItem('calendarState')) as IStartupState;

if (startupState !== null) {
    localStorage.removeItem('calendarState');
} else {
    const queryStringArgs = getQueryStringMap(['startDate', 'endDate', 'type', 'genre', 'accessibility', 'discount', 'presenter']);

    startupState = {
        currentDate: queryStringArgs.has('startDate') ? queryStringArgs.get('startDate') : moment().clone().format('YYYY-MM-DD'),
        startDate: queryStringArgs.has('startDate') ? queryStringArgs.get('startDate') : moment().clone().format('YYYY-MM-DD'),
        endDate: queryStringArgs.has('endDate') ? queryStringArgs.get('endDate') : undefined,
        dateRangeFromQueryString: queryStringArgs.has('endDate'),
        typeFilter: queryStringArgs.has('type') ? queryStringArgs.get('type').split(',') : [],
        genreFilter: queryStringArgs.has('genre') ? queryStringArgs.get('genre').split(',') : [],
        venueFilter: queryStringArgs.has('location') ? queryStringArgs.get('location').split(',') : [],
        availabilityFilter: queryStringArgs.has('availability') ? queryStringArgs.get('availability').split(',') : []
    }
}


//function discountSwitch(input: string): string {
//    switch (input) {
//        case "bravo":
//            return String(DiscountTag.Bravo);
//        case "myTix":
//            return String(DiscountTag.MyTix);
//        case "studentRush":
//            return String(DiscountTag.StudentRush);
//        default:
//            return "";
//    }
//}

export const defaultStartupState: IStartupState = startupState;


